export const baseURL="https://doggis-2.herokuapp.com"
export const local="http://localhost:3002"

